/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Rest_Api_C3Inputs */

const en_guide_json_rest_api_c3 = /** @type {(inputs: Guide_Json_Rest_Api_C3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Response designs that survive their second version`)
};

const ko_guide_json_rest_api_c3 = /** @type {(inputs: Guide_Json_Rest_Api_C3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`두 번째 버전까지 살아남는 응답 설계`)
};

const ja_guide_json_rest_api_c3 = /** @type {(inputs: Guide_Json_Rest_Api_C3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2番目のバージョンまで生き残るレスポンス設計`)
};

/**
* | output |
* | --- |
* | "Response designs that survive their second version" |
*
* @param {Guide_Json_Rest_Api_C3Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_rest_api_c3 = /** @type {((inputs?: Guide_Json_Rest_Api_C3Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Rest_Api_C3Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_rest_api_c3(inputs)
	if (locale === "ko") return ko_guide_json_rest_api_c3(inputs)
	return ja_guide_json_rest_api_c3(inputs)
});